/**
 * Block: Employees
 *
 * Clicking an employee opens the matching modal. The `show` class flips the
 * modal to `display: grid`; `anim` is added on the next frame so the opacity
 * transition has a state to animate from and the modal fades in smoothly.
 *
 * While a modal is open (below the breakpoint) the body gets `no-scroll`, and a
 * click outside the modal — or on its close icon — dismisses it.
 *
 * Each employees block on the page wires up independently with its own open
 * state, so multiple blocks can coexist.
 */

// From this width up the modal aligns to the clicked employee instead of being
// centred in the viewport (see the CSS default).
const alignQuery = window.matchMedia('(min-width: 768px)');

function initEmployeesBlock(section) {
  const links = section.querySelectorAll('.employee-link');
  const modals = section.querySelectorAll('.employee-modal');
  let openModalEl = null;

  function openModal(modal, link) {
    openModalEl = modal;

    if (alignQuery.matches) {
      // Pin the modal's top to the clicked employee's top. The modal is
      // position:absolute inside the <ul>, so offset relative to the <ul>.
      const li = link.closest('li');
      const ul = li.closest('ul');
      const top = li.getBoundingClientRect().top - ul.getBoundingClientRect().top;
      modal.style.top = top + 'px';
    } else {
      // Below the breakpoint the modal is centred and covers the screen, so
      // lock body scrolling behind it.
      document.body.classList.add('no-scroll');
    }

    modal.classList.add('show');
    // Next frame: the modal is now displayed, so toggling `anim` transitions.
    requestAnimationFrame(() => {
      modal.classList.add('anim');
    });
  }

  function closeModal(modal) {
    openModalEl = null;
    modal.classList.remove('anim');
    document.body.classList.remove('no-scroll');
    // Wait for the fade-out before removing it from the layout.
    modal.addEventListener(
      'transitionend',
      () => {
        modal.classList.remove('show');
        // Clear the inline positioning so the centred CSS default returns.
        modal.style.top = '';
      },
      { once: true }
    );
  }

  links.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      // Keep this click from reaching the outside-click handler below.
      e.stopPropagation();

      // If a modal is already open, close it instead of opening another.
      if (openModalEl) {
        closeModal(openModalEl);
        return;
      }

      const id = link.closest('li').id;
      const modal = section.querySelector(
        '.employee-modal[data-id="' + id + '"]'
      );

      if (modal) {
        openModal(modal, link);
      }
    });
  });

  // Close on the modal's close icon.
  modals.forEach(function (modal) {
    const closeIcon = modal.querySelector('svg');
    if (closeIcon) {
      closeIcon.addEventListener('click', function () {
        closeModal(modal);
      });
    }
  });

  // Close when clicking anywhere outside this block's open modal.
  document.addEventListener('click', function (e) {
    if (openModalEl && !openModalEl.contains(e.target)) {
      closeModal(openModalEl);
    }
  });
}

document.querySelectorAll('section.employees').forEach(initEmployeesBlock);
